//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ObjectSnippet from '@/components/objects/ObjectSnippet.vue'
import { STORAGE_IMAGE_PATH } from '@/constants/ui.js'

export default {
  name: 'CategoryTopItemsCarousel',
  components: { ObjectSnippet },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ready: false,
      swiper: null,
    }
  },
  computed: {
    materialCategories() {
      return this.$store.state.art.materialCategories || []
    },
  },
  watch: {
    items: {
      handler() {
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.update()
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (!process.client) {
      return
    }

    const swiperEl = this.$refs.swiperContainer
    const markReady = () => {
      this.ready = true
      return this.$nextTick()
    }

    this.$watch(
      'items',
      (newVal) => {
        if (!newVal || !newVal.length) {
          return
        }

        import('@/plugins/swiper.js').then(({ Swiper, Navigation }) => {
          if (this.swiper) {
            this.swiper.destroy()
            this.swiper = null
          }

          this.swiper = new Swiper(swiperEl, {
            preventClicks: true,
            preventClicksPropagation: true,
            touchStartPreventDefault: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            init: true,
            navigation: {
              nextEl: '.category-top-btn-next',
              prevEl: '.category-top-btn-prev',
            },
            modules: [Navigation],
            observer: true,
            observeParents: true,
            on: {
              init: async (swiper) => {
                await markReady()
                swiper.update()
              },
            },
            breakpoints: {
              750: {
                spaceBetween: 24,
              },
              1100: {
                spaceBetween: 30,
              },
            },
          })
        })
      },
      { immediate: true },
    )
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  },
  methods: {
    itemKey(item) {
      const kind = item._topKind === 'art' ? 'art' : 'enc'
      return `${kind}:${item.id}`
    },
    snippetViewName(item) {
      if (item._topKind === 'art') {
        return item.is_spec_project ? 'sp-slug' : 'art-slug'
      }
      return 'objects-slug'
    },
    snippetImagePath(item) {
      if (item._topKind === 'art') {
        return [`${STORAGE_IMAGE_PATH}$id`, 'cover']
      }

      return undefined
    },
  },
}
